import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

import { BehaviorSubject, catchError, filter, map, of, switchMap, tap } from 'rxjs';

import { Absence } from '../models/absence';

import { TimeSheetService } from './time-sheet-service';

@Injectable({
  providedIn: 'root',
})
export class AbsencesDaysService {
  private http = inject(HttpClient);
  private timeSheetService = inject(TimeSheetService);

  private readonly refresh$ = new BehaviorSubject<{ year: number; month: number } | null>(null);
  private readonly loading$ = new BehaviorSubject<boolean>(false);

  refreshVacationDays(year: number, month: number) {
    this.refresh$.next({ year, month });
  }

  private readonly absenceDays$ = this.refresh$.pipe(
    filter((r) => r !== null),
    tap(() => this.loading$.next(true)),
    switchMap((params) => {
      return this.http.get<Absence[]>(`/Absences/${params?.year}/${params?.month}`).pipe(
        map((data) =>
          data.map((abs) => ({
            ...abs,
            date: new Date(abs.date),
          }))
        ),
        catchError(() => of([])),
        tap(() => this.loading$.next(false))
      );
    })
  );

  readonly absenceDays = toSignal(this.absenceDays$);
  readonly isLoading = toSignal(this.loading$, { initialValue: false });

  generateAbsencesTimeSheet(year: number, month: number) {
    return this.http
      .post(`/Absences/${year}/${month}/generate`, {})
      .pipe(tap(() => this.timeSheetService.refreshTimeSheetData(year, month)));
  }
}
